module.exports = __webpack_public_path__ + "static/img/manual-50.728fcf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-50.png
// module id = qrOp
// module chunks = 4